import React, { useCallback, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeSavePuzzleRequest } from "API/Puzzles";

import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";

import "./PublicCrossword/PublicCrossword.css";

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

function createEmptyGrid(size) {
  const grid = [];
  for (let i = 0; i < size; i++) {
    const row = [];
    for (let j = 0; j < size; j++) {
      row.push({ letter: "", answer: "" });
    }
    grid.push(row);
  }
  return grid;
}

function isValidPosition(row, col, gridSize) {
  return row >= 0 && row < gridSize && col >= 0 && col < gridSize;
}

function isAdjacentValid(grid, row, col, gridSize, direction) {
  const directions = [
    { row: -1, col: 0 }, // up
    { row: 1, col: 0 }, // down
    { row: 0, col: -1 }, // left
    { row: 0, col: 1 }, // right
  ];

  for (const { row: dRow, col: dCol } of directions) {
    const newRow = row + dRow;
    const newCol = col + dCol;
    if (isValidPosition(newRow, newCol, gridSize)) {
      const cell = grid[newRow][newCol];
      if (cell.answer && direction !== dRow && direction !== dCol) {
        return false;
      }
    }
  }
  return true;
}

function canPlaceWord(grid, word, row, col, direction, gridSize) {
  if (direction === "right") {
    if (col + word.length > gridSize) return false;
    if (
      row !== 0 &&
      grid[row - 1][col].answer &&
      grid[row][col].answer !== word[0]
    ) {
      return false;
    }
    if (
      col !== 0 &&
      grid[row][col - 1].answer &&
      grid[row][col].answer !== word[0]
    ) {
      return false;
    }
    for (let i = 0; i < word.length; i++) {
      const currentCol = col + i;
      if (
        grid[row][currentCol].answer &&
        grid[row][currentCol].answer !== word[i]
      ) {
        return false;
      }
      // if (
      //   row !== 0 &&
      //   grid[row - 1][currentCol].answer 
      //   // &&
      //   // grid[row][currentCol].answer !== word[i]
      // ) {
      //   return false;
      // }
      // if (
      //   currentCol !== 0 &&
      //   grid[row][currentCol - 1].answer &&
      //   grid[row][currentCol].answer !== word[i]
      // ) {
      //   return false;
      // }

      if ( currentCol < gridSize -1 && i === word.length - 1 &&
        grid[row][currentCol+1].answer) {
      }
      if (
        !isAdjacentValid(grid, row, currentCol, gridSize, 0) &&
        grid[row][currentCol].answer !== word[i]
      ) {
        return false;
      }
    }
  } else if (direction === "down") {
    if (row + word.length > gridSize) return false;
    if (
      row !== 0 &&
      grid[row - 1][col].answer &&
      grid[row][col].answer !== word[0]
    ) {
      return false;
    }
    if (
      col !== 0 &&
      grid[row][col - 1].answer &&
      grid[row][col].answer !== word[0]
    ) {
      return false;
    }
    for (let i = 0; i < word.length; i++) {
      const currentRow = row + i;
      if (
        grid[currentRow][col].answer &&
        grid[currentRow][col].answer !== word[i]
      ) {
        return false;
      }

      // if (
      //   currentRow !== 0 &&
      //   grid[currentRow - 1][col].answer &&
      //   grid[currentRow][col].answer !== word[i]
      // ) {
      //   return false;
      // }
      // if (
      //   col !== 0 &&
      //   grid[currentRow][col - 1].answer &&
      //   grid[currentRow][col - 1].answer !== word[i]
      // ) {
      //   return false;
      // }
      if ( currentRow < gridSize -1 && i === word.length - 1 &&
        grid[currentRow+1][col].answer) {
          return false;
      }
      if (
        !isAdjacentValid(grid, currentRow, col, gridSize, 1) &&
        grid[currentRow][col].answer !== word[i]
      ) {
        return false;
      }
    }
  }
  return true;
}

function placeWord(grid, word, row, col, direction) {
  if (direction === "right") {
    for (let i = 0; i < word.length; i++) {
      grid[row][col + i].answer = word[i];
    }
  } else if (direction === "down") {
    for (let i = 0; i < word.length; i++) {
      grid[row + i][col].answer = word[i];
    }
  }
}

function wordSharesLetter(grid, word, row, col, direction) {
  if (direction === "right") {
    for (let i = 0; i < word.length; i++) {
      if (grid[row][col + i].answer === word[i]) {
        return true;
      }
    }
  } else if (direction === "down") {
    for (let i = 0; i < word.length; i++) {
      if (grid[row + i][col].answer === word[i]) {
        return true;
      }
    }
  }
  return false;
}

function assignClueNumbers(wordsAndClues) {
  const acrossClues = [];
  const downClues = [];
  const clueNumbers = {};
  let nextClueNumber = 1;

  for (const { clue, col, row, direction, word } of wordsAndClues) {
    const clueKey = `${row},${col}`;
    let clueNumber;

    if (clueKey in clueNumbers) {
      clueNumber = clueNumbers[clueKey];
    } else {
      clueNumber = nextClueNumber++;
      clueNumbers[clueKey] = clueNumber;
    }

    const clueEntry = {
      number: clueNumber,
      clue: clue,
      word: word,
      position: { col: col, row: row },
    };

    if (direction === "right") {
      acrossClues.push(clueEntry);
    } else if (direction === "down") {
      downClues.push(clueEntry);
    }
  }

  return {
    across: acrossClues,
    down: downClues,
  };
}

// Function to remove a column from a grid
function removeColumn(grid, colIndex) {
  // Check if the column index is valid
  if (colIndex < 0 || colIndex >= grid[0].length) {
    throw new Error("Invalid column index");
  }

  // Create a new grid with the specified column removed
  const newGrid = grid.map((row) => {
    // Use slice to create a new array excluding the specified column
    return row.filter((_, index) => index !== colIndex);
  });

  return newGrid;
}

function removeEmptyAnswerColumns(grid) {
  if (!grid.length) return grid; // Return if the grid is empty

  const numRows = grid.length;
  const numCols = grid[0].length;
  const columnsToRemove = [];

  // Identify columns with empty .answer property
  for (let col = 0; col < numCols; col++) {
    if (grid.every((row) => row[col].answer === "")) {
      columnsToRemove.push(col);
    }
  }

  // Create a new grid excluding the identified columns
  const newGrid = grid.map((row) =>
    row.filter((_, index) => !columnsToRemove.includes(index))
  );

  return newGrid;
}

function fitWordsIntoCrossword(wordsAndClues, gridSize = 12) {
  let maxGrid = null;
  let maxPlaced = 0;
  let clueLocations = [];
  for (let trial = 0; trial < 20; trial += 1) {
    const grid = createEmptyGrid(gridSize);
    let firstWordPlaced = false;
    let numPlaced = 0;
    let draftClueLocations = [];
    // shuffleArray(wordsAndClues);

    for (const { word, clue } of wordsAndClues) {
      let placed = false;
      const attempts = gridSize * gridSize * 2; // Arbitrary number of attempts to try and place the word

      for (let attempt = 0; attempt < attempts && !placed; attempt++) {
        const row = getRandomInt(gridSize);
        const col = getRandomInt(gridSize);
        const direction = Math.random() > 0.5 ? "right" : "down";

        if (canPlaceWord(grid, word, row, col, direction, gridSize)) {
          if (
            !firstWordPlaced ||
            wordSharesLetter(grid, word, row, col, direction)
          ) {
            placeWord(grid, word, row, col, direction);
            placed = true;
            numPlaced += 1;
            firstWordPlaced = true;
            draftClueLocations.push({ word, clue, row, col, direction });
          }
        }
      }

      if (!placed) {
        console.log(`Could not place the word: ${word}`);
      }
    }
    if (numPlaced > maxPlaced) {
      maxPlaced = numPlaced;
      maxGrid = grid;
      clueLocations = draftClueLocations;
    }
  }
  return { maxGrid, clueLocations };
}

const Crossword = (props) => {
  const { onClickBack, draftWordsAndClues, puzzleTitle, edit } = props;
  const dispatch = useDispatch();
  const [generateCrossword, setGenerateCrossword] = useState(!edit);
  const puzzleSlice = useSelector((state) => state.puzzleSlice);

  const wordsAndCluesRedux = useSelector(
    (state) => state.puzzleSlice?.puzzle?.wordsAndClues
  );
  const wordsAndClues = draftWordsAndClues?.length
    ? draftWordsAndClues
    : wordsAndCluesRedux;
  const authToken = useSelector((state) => state.authSlice?.authToken);

  const puzzleId = useSelector((state) => state.puzzleSlice?.puzzleId);
  const puzzle = useSelector((state) => state.puzzleSlice?.puzzle);
  const clues = useSelector((state) => state.puzzleSlice?.puzzle?.clues);
  const grid = useSelector((state) => state.puzzleSlice?.puzzle?.grid);

  const handleSaveCrossword = useCallback(async () => {
    const draftPuzzle = {
      ...puzzle,
      wordsAndClues,
    };
    const savePuzzleParam = {
      id: puzzleId,
      puzzle: draftPuzzle,
      puzzleType: "crossword",
      title: puzzleTitle,
    };

    await makeSavePuzzleRequest(dispatch, authToken, savePuzzleParam);
  }, [dispatch, authToken, puzzle, puzzleId, puzzleTitle, wordsAndClues]);

  const handleRegenerateCrossword = () => {
    console.log("click");
    setGenerateCrossword(true);
  };

  useEffect(() => {
    // console.log("Runnign!", { wordsAndClues });

    if (!wordsAndClues || !wordsAndClues.length || (grid && !generateCrossword))
      return;
    const { maxGrid, clueLocations } = fitWordsIntoCrossword(wordsAndClues);

    const { across, down } = assignClueNumbers(clueLocations);
    across.forEach((acrossClue) => {
      const { number, clue, word, position } = acrossClue;
      maxGrid[position.row][position.col] = {
        ...maxGrid[position.row][position.col],
        clueNumber: number,
      };
    });
    down.forEach((downClue) => {
      const { number, clue, word, position } = downClue;
      maxGrid[position.row][position.col] = {
        ...maxGrid[position.row][position.col],
        clueNumber: number,
      };
    });
    dispatch(
      setPuzzleAndPuzzleType({
        ...puzzleSlice,
        puzzle: {
          ...puzzleSlice?.puzzle,
          grid: maxGrid,
          clues: { across, down },
        },
      })
    );
    setGenerateCrossword(false);
  }, [wordsAndClues, dispatch, setPuzzleAndPuzzleType, generateCrossword]);

  // const handleChange = (rowIndex, colIndex, value) => {
  //   const newGrid = grid?.map((row, rIdx) =>
  //     row?.map((cell, cIdx) => {
  //       if (rIdx === rowIndex && cIdx === colIndex && cell.answer) {
  //         return { ...cell, letter: value.toUpperCase() };
  //       }
  //       return cell;
  //     })
  //   );
  //   setPuzzleAndPuzzleType({
  //     ...puzzleSlice,
  //     puzzle: { ...puzzleSlice?.puzzle, grid: newGrid },
  //   });
  // };

  const checkAnswers = () => {
    const isCorrect = grid.every((row) =>
      row.every((cell) => cell.answer === "" || cell.letter === cell.answer)
    );
    alert(isCorrect ? "Correct!" : "Try again!");
  };

  const handleCrosswordContent = useCallback((wordsAndClues) => {
    dispatch(
      setPuzzleAndPuzzleType({
        puzzleType: "crossword",
        puzzle: { wordsAndClues },
      })
    );
  }, []);

  const cellBelow = useCallback(
    (rowI, cellI) => {
      return (
        grid &&
        grid[rowI + 1] &&
        grid[rowI + 1][cellI] &&
        grid[rowI + 1][cellI].answer
      );
    },
    [grid]
  );

  const cellAbove = useCallback(
    (rowI, cellI) => {
      // console.log({rowI, cellI})
      // if (grid[rowI - 1]) console.log(grid[rowI - 1][cellI])

      return grid && grid[rowI - 1] && grid[rowI - 1][cellI];
    },
    [grid]
  );

  const cellToRight = useCallback(
    (rowI, cellI) => {
      return (
        grid &&
        grid[rowI] &&
        grid[rowI][cellI + 1] &&
        grid[rowI][cellI + 1].answer
      );
    },
    [grid]
  );

  const cellToLeft = useCallback(
    (rowI, cellI) => {
      return (
        grid &&
        grid[rowI] &&
        grid[rowI][cellI - 1] &&
        grid[rowI][cellI - 1].answer
      );
    },
    [grid]
  );

  return (
    <>
      <div className="create-games-topbar-container">
        <div className="create-games-topbar-back-button" onClick={onClickBack}>
          <b>{"< "}</b>Back
        </div>
        <div
          className="create-games-topbar-regenerate-button"
          onClick={handleRegenerateCrossword}
        >
          Regenerate
        </div>
        <div
          className="create-games-topbar-continue-button"
          name='save-puzzle'
          onClick={handleSaveCrossword}
        >
          Save<b>{" >"}</b>
        </div>
      </div>
      <div className="crossword-editor-container">
        <div className="crossword-container">
          <div className="crossword-clue-section-container">
            Clues
            <div className="crossword-clues-container">
              <div className="crossword-clue-container">
                <b>Across</b>
              </div>
              {clues?.across?.map((c) => (
                <div className="crossword-clue-container">
                  <b></b>
                  {c.number}: {c.clue}
                </div>
              ))}
              <div className="crossword-clue-container">
                <b>Down</b>
              </div>
              {clues?.down?.map((c) => (
                <div className="crossword-clue-container">
                  <b></b>
                  {c.number}: {c.clue}
                </div>
              ))}
            </div>
          </div>
          <div className="crossword-grid">
            {grid?.map((row, rowIndex) => {
              const emptyRow = row?.every((c) => !c.answer);

              return (
                <div
                  key={rowIndex}
                  className={`crossword-row ${emptyRow ? "empty" : ""}`}
                >
                  {row?.map((cell, colIndex) => {
                    const isCellBelow = cellBelow(rowIndex, colIndex);
                    const isCellAbove = cellAbove(rowIndex, colIndex);

                    const isCellToRight = cellToRight(rowIndex, colIndex);
                    const isCellToLeft = cellToLeft(rowIndex, colIndex);

                    return (
                      <div
                        className={`${cell.answer ? "cell" : "cell empty"} ${
                          isCellBelow ? "cellBelow" : ""
                        } ${isCellAbove ? "cellAbove" : ""} ${
                          isCellToRight ? "cellToRight" : ""
                        } ${isCellToLeft ? "cellToLeft" : ""}`}
                        key={colIndex}
                      >
                        {cell.answer && (
                          <div className="cell-content">
                            <span className="clue-number">
                              {cell.clueNumber}
                            </span>
                            {cell.answer}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Crossword;
